import { DEPLOY_ENV } from '@base/constants'
import { getOpenAppSensorsPublicParams, getUrlParams, needDecodeURIComponent } from '@r/page/src/utils'
import sensors from 'sa-sdk-javascript'

export const SensorsInit = () => {
  sensors.init({
    server_url: `https://shence-prod.cdfsunrise.com:8106/sa?project=${DEPLOY_ENV === 'prod' ? 'production' : 'default'}`,
    show_log: true, //日志输出
    is_track_single_page: true, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
    use_client_time: true,
    app_js_bridge: {
      white_list: ['https://shence-prod.cdfsunrise.com:8106/sa?project=default', 'https://shence-prod.cdfsunrise.com:8106/sa?project=production'],
    }, //app端打通
    send_type: 'beacon',
    heatmap: {
      //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
      clickmap: 'default',
      //是否开启触达注意力图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
      scroll_notice_map: 'default',
    },
  })

  sensors.registerPage({
    platform_type: 'h5',
    current_page_url: location.href,
    current_page_name: 'downloadpage',
    refer_page_name: 'N/A',
  })

  const quickParams: Record<string, string> = {
    platform: 'h5',
    // http://localhost:8080/r/download/index.html?messagetype=market&msg_channel=sms&source_from=summer2024
    ...getOpenAppSensorsPublicParams(),
  }

  sensors.quick('autoTrack', quickParams) //用于采集 $pageview 事件。
}

/**神策统计事件 */
// let sensorsLastTicker: any
export const sensorsTrack = (name: string, cnName: string, data?: Record<string, unknown>) => {
  // const gap = 2200
  const track = () => {
    // 神策bug，导致小程序连续点击，跳转两个页面
    // setTimeout(() => {
    sensors.track(name, {
      // name: cnName,
      ...(data || {}),
    })
    // }, 200)
  }
  track()
}

export default sensors
